<template>
  <el-select v-model="selectValues"
             v-bind="$attrs"
             style="width: 100%"
             v-on="listeners"
             multiple
             collapse-tags
             clearable
             placeholder="请选择"
             @change="changeSelect">
    <el-option v-if="options.length"
               label="全选"
               value="全选">
      <input type="checkbox"
             class="checkbox"
             v-model="isSelectAll" /> 全选
    </el-option>
    <el-row style="width: 100%; max-width: 820px;">
      <el-col v-for="(item,index) in options"
              :key="index"
              :span="8">
        <el-option :key="item[config.value]"
                   :label="item[config.label]"
                   :value="item[config.value]">
          <input type="checkbox"
                 class="checkbox"
                 v-model="item.isCheck" /> <span :title="item[config.label]">{{ item[config.label]}}</span>
        </el-option>
      </el-col>
    </el-row>
  </el-select>
</template>
 
<script>
/**
 * @desc 下拉多选组件
 * @param config {Object}  配置对象 包含 接口地址 转义名称
 *
 * 如若传 configOptions 将以configOptions 为数据源 从而忽略 api
 */
import emitter from 'element-ui/src/mixins/emitter' // 分发事件的el-form处理方法
import { getDictionaries } from '@/basic-common/util/dictionaries.js'
export default {
  name: 'CheckboxSelect',
  mixins: [emitter],
  inheritAttrs: false,
  model: {
    prop: 'initSelectValues',
    event: 'change',
  },
  props: {
    initSelectValues: {
      type: Array,
      default: () => [],
    },
    // 配置对象
    config: {
      type: Object,
      default: () => {
        return {
          api: '/api/blade-system/dept/searchAllDept?type=3&business=1',
          label: 'deptName',
          value: 'id',
        }
      },
    },
    // 配置数组
    configOptions: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      isCheck: true,
      options: [],
      selectValues: [],
      isSelectAll: false,
    }
  },
  watch: {
    // 监听（全选，全不选以及checkbox是否勾选）
    selectValues: {
      handler(arr) {
        this.options.forEach((item) => {
          if (arr.includes(item[this.config.value])) {
            this.$set(item, 'isCheck', true)
          } else {
            this.$set(item, 'isCheck', false)
          }
        })

        if (this.options.length && arr.length === this.options.length) {
          this.isSelectAll = true
        } else {
          this.isSelectAll = false
        }
        this.$nextTick(() => {
          this.$forceUpdate()
        })
        // 强制更新（checkbox回显)
        // this.dispatch('ElFormItem', 'el.form.change', this.selectValues || [])
      },
      immediate: true,
    },
  },
  async created() {
    if (this.configOptions) {
      this.options = this.configOptions
    } else {
      this.options = await getDictionaries(this.config.api)
    }
    // 回显
    this.selectValues = this.initSelectValues
  },

  methods: {
    changeSelect(val) {
      if (val.includes('全选')) {
        if (val.length > this.options.length) {
          this.selectValues = []
        } else {
          this.selectValues = this.options.map(
            (item) => item[this.config.value]
          )
        }
      }
      this.$emit('change', this.selectValues)
    },
  },
}
</script>
 
<style lang="scss" scoped>
// 多选框√去掉
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}

.checkbox {
  display: inline-block;
  position: relative;
  vertical-align: text-top;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  margin-left: 5px;
  background-color: #fff;
  z-index: 1;
}
</style>